// Backyard scenes for the "picture it in your backyard" swapper + social assets.
const CDN = "https://static.prod-images.emergentagent.com/jobs/37d006de-37ac-493c-88f8-207130788384/images/";

export const BACKYARDS = [
  { id: "deck", name: "Timber Deck", image: CDN + "9e4a158eeb3e8bddb76b0485097511d45be7b5b1f4e139033dc0722a1d2a3aa8.jpeg" },
  { id: "lawn", name: "Garden Lawn", image: CDN + "0b8c9c6768f562cfc5d1cf31912f4260f752c3a587b174e25cbaeb7f3b782848.jpeg" },
  { id: "coastal", name: "Coastal View", image: CDN + "f038e471dca3f6ccf02a69e29840dd4916be80dbcf3d25383b02a4facec84cbf.jpeg" },
  { id: "courtyard", name: "Courtyard", image: CDN + "e6f28127af1cbf09cbfe6478bcff650ff1c696c966eac753a231e6ca62f3d7de.jpeg" },
];

// Indoor / under-cover scenes for the sauna "See this sauna in my home" swapper.
export const SAUNA_SCENES = [
  { id: "balcony", name: "Covered Balcony", image: CDN + "3319bc23de820d7194f020fbd86fe693e51af7eb29d6f6efa690accaa56def68.jpeg" },
  { id: "gym", name: "Home Gym", image: CDN + "b80fcaafe1b8278ae7f2cabf654efd24e019b3f78587452cc0b6de6682db8706.jpeg" },
  { id: "living", name: "Living Room", image: CDN + "434489e07f5ed9c3f93fe0b2727f163a06019f8d3370864aba45ee1dfe6e865d.jpeg" },
  { id: "patio", name: "Alfresco Patio", image: CDN + "a66e2d9ad7e86ad0fe3dd52d1ac988dda4993f249d70542b73c9b7400393a170.jpeg" },
  { id: "cabana", name: "Poolside Cabana", image: CDN + "7ed488534b7eee733278f9e0e179b17c98c1fdbdb6ac972b9cbfd50f5b79cdd3.jpeg" },
  { id: "ensuite", name: "Ensuite Retreat", image: CDN + "2c797ee4bbd26e6c746832ec7ad88a08a007e1c6ca6c6cb3b29edca5a4c45a07.jpeg" },
];

export const REELS = [
  {
    slug: "aerial-1", title: "Aerial flyover (9:16)",
    video: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-1.mp4`,
    poster: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-1.jpg`,
    caption: "Cinematic aerial views over Just Spas. 🚁 Take the full virtual tour. ☎ 02 4942 3212 #JustSpasNewcastle #DroneView",
  },
  {
    slug: "aerial-2", title: "Backyard from above (9:16)",
    video: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-2.mp4`,
    poster: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-2.jpg`,
    caption: "Your backyard from above ✨ Explore spas, swim spas & pools in our Virtual Showroom. #SwimSpa #Newcastle",
  },
  {
    slug: "aerial-3", title: "Resort at home (9:16)",
    video: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-3.mp4`,
    poster: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-3.jpg`,
    caption: "Bring the resort home. 🌿 Tour the range now — link in bio. #JustSpasNewcastle #BackyardGoals",
  },
  {
    slug: "sauna-lifestyle", title: "Sauna warm-glow (9:16)",
    video: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-sauna.mp4`,
    poster: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-sauna.jpg`,
    caption: "Bring the warmth home. 🔥 Indoor infrared saunas — 1 to 4 person. Explore the range in our Virtual Showroom. ☎ 02 4942 3212 #WellnessSauna #InfraredSauna #JustSpasNewcastle",
  },
  {
    slug: "urban-pool", title: "Urban Pool (9:16)",
    video: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-urban.mp4`,
    poster: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-urban.jpg`,
    caption: "Resort-style living at home. 🌊 Explore our Urban Pools in the Virtual Showroom. ☎ 02 4942 3212 #UrbanPool #PlungePool #JustSpasNewcastle",
  },
  {
    slug: "factory-build", title: "Aussie Made (9:16)",
    video: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-factory.mp4`,
    poster: `${process.env.REACT_APP_BACKEND_URL}/api/media/reels/reel-factory.jpg`,
    caption: "Proudly Australian made. 🇦🇺 See how our spas are built. Tour the range in our Virtual Showroom. #AustralianMade #JustSpasNewcastle",
  },
];

export const SOCIAL_ASSETS = [
  {
    slug: "spa_portrait", title: "Spa — Story / Reel (9:16)", ratio: "portrait",
    url: CDN + "b8a746447f54c00d60c5661717c0882cb741b30dff71930767bd4559164e9f9a.jpeg",
    caption: "Your backyard. Reimagined. 🌙 Step inside our Virtual Showroom and picture your dream spa under the stars. Link in bio ☎ 02 4942 3212 #JustSpasNewcastle #SpaLife #Newcastle",
  },
  {
    slug: "swim_portrait", title: "Swim Spa — Story / Reel (9:16)", ratio: "portrait",
    url: CDN + "7c97c44f627b525fd3afc56aca3e06129e568d1443be62f6f7ce614f1d319970.jpeg",
    caption: "Swim, train, relax — all year round. 🏊 Explore our swim spas in the Virtual Showroom. #SwimSpa #JustSpasNewcastle #Hydrotherapy",
  },
  {
    slug: "spa_square", title: "Lifestyle — Couple (1:1)", ratio: "square",
    url: `${process.env.REACT_APP_BACKEND_URL}/api/media/lifestyle-couple-swimspa.jpg`,
    caption: "Warm water. Cool nights. Zero stress. Take the virtual tour and find your perfect spa. ☎ 02 4942 3212 #SpaGoals #Newcastle",
  },
  {
    slug: "urban_square", title: "Urban Pool — Feed Post (1:1)", ratio: "square",
    url: CDN + "1c18df1d14bd7618c5b36186e6cd2b8533e75755cc3176789f4654141d62f940.jpeg",
    caption: "The pool your backyard has been waiting for. 💧 Configurable Urban Pools — tour them now in our Virtual Showroom. #UrbanPool #JustSpasNewcastle",
  },
];
